// constants
import { showSuccessAlert } from "../../constants/alerts";
import { NewsActionTypes } from "./constants";

const INIT_STATE = {
  news: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface newsData {
  id: number;
  title_en: string;
  title_ar: string;
  description_en: string;
  description_ar: string;
  images: File | null;
}

interface NewsActionType {
  type:
    | NewsActionTypes.API_RESPONSE_SUCCESS
    | NewsActionTypes.API_RESPONSE_ERROR
    | NewsActionTypes.CREATE_NEWS
    | NewsActionTypes.UPDATE_NEWS
    | NewsActionTypes.GET_NEWS
    | NewsActionTypes.DELETE_IMAGE
    | NewsActionTypes.DELETE_NEWS;
  payload: {
    actionType?: string;
    data?: newsData | {};
    error?: string;
    news?: [];
  };
}

interface State {
  news?: newsData[] | [];
  loading?: boolean;
  value?: boolean;
}

const NewsStates = (state: State = INIT_STATE, action: NewsActionType): any => {
  switch (action.type) {
    case NewsActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case NewsActionTypes.CREATE_NEWS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case NewsActionTypes.GET_NEWS: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            news: action.payload.data,
          };
        }
        case NewsActionTypes.UPDATE_NEWS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case NewsActionTypes.DELETE_NEWS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case NewsActionTypes.DELETE_IMAGE: {
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case NewsActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case NewsActionTypes.CREATE_NEWS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case NewsActionTypes.UPDATE_NEWS: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case NewsActionTypes.GET_NEWS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case NewsActionTypes.DELETE_NEWS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case NewsActionTypes.DELETE_IMAGE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case NewsActionTypes.CREATE_NEWS:
      return { ...state, loading: true };
    case NewsActionTypes.UPDATE_NEWS:
      return { ...state, loading: true };
    case NewsActionTypes.GET_NEWS:
      return { ...state, loading: true, initialLoading: true };
    case NewsActionTypes.DELETE_NEWS:
      return { ...state, loading: true };
    case NewsActionTypes.DELETE_IMAGE:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default NewsStates;
